import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged, setPersistence, browserLocalPersistence } from 'firebase/auth'

const DEFAULT_AUTH_DOMAIN = 'plantoride.firebaseapp.com'

const getRuntimeHostname = () => {
  if (typeof window === 'undefined') return ''
  return (window.location?.hostname || '').toLowerCase()
}

const isLocalRuntimeHost = (hostname) => {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
}

const resolveAuthDomain = () => {
  const configured = (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '').trim().toLowerCase()
  if (configured) {
    return configured
  }

  const runtimeHost = getRuntimeHostname()
  if (runtimeHost && !isLocalRuntimeHost(runtimeHost)) {
    // Keep helper and app on the same host in production-like environments.
    return runtimeHost
  }

  return DEFAULT_AUTH_DOMAIN
}

const resolvedAuthDomain = resolveAuthDomain()

const firebaseConfig = {
  apiKey: 'AIzaSyDCsIM4wMDyiQFAtVuAy6H-eucdvmeAwxM',
  authDomain: resolvedAuthDomain,
  projectId: 'plantoride',
  storageBucket: 'plantoride.appspot.com',
  messagingSenderId: '168042135067',
  appId: '1:168042135067:web:06c98fbcdfced2a91542be',
  measurementId: 'G-TH11V00HPH'
}

export const initFirebase = () => {
  return initializeApp(firebaseConfig)
}

export const getAuthDomain = () => resolvedAuthDomain

export const isRedirectAuthSupportedForCurrentOrigin = () => {
  const runtimeHost = getRuntimeHostname()
  if (!runtimeHost) return false
  return runtimeHost === resolvedAuthDomain
}

let auth = null
let authInitPromise = null
export const getAuthInstance = () => {
  if (!auth) {
    auth = getAuth()
  }
  return auth
}

// Ensure Firebase Auth restores the persisted session before guards run
export const ensureAuthInitialized = () => {
  const a = getAuthInstance()
  if (!authInitPromise) {
    try {
      // Explicitly persist auth state in local storage
      setPersistence(a, browserLocalPersistence)
    } catch {
      /* ignore persistence setup failures */
    }
    authInitPromise = new Promise((resolve) => {
      const unsub = onAuthStateChanged(a, () => {
        unsub()
        resolve(true)
      })
    })
  }
  return authInitPromise
}
